var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTimeSpeed = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "time-speed_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 120,
  height: 120
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h120v120H0V0Z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#time-speed_svg__a)",
  stroke: "#88CA11",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M97.18 107.992c-17.444 11.36-41.036 9.386-56.344-5.921-17.573-17.574-17.573-46.066 0-63.64 17.574-17.573 46.066-17.573 63.64 0 15.293 15.293 17.278 38.855 5.954 56.294"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.656 104.266c-18.785 0-34.014-15.23-34.014-34.015 0-18.786 15.229-34.015 34.014-34.015 18.786 0 34.015 15.23 34.015 34.015 0 18.786-15.229 34.015-34.015 34.015ZM64.183 15.999h16.875a5.625 5.625 0 1 0 0-11.25H64.183a5.625 5.625 0 1 0 0 11.25ZM80.638 25.251v-9.252H64.603v9.252M77.099 65.809l12.04-12.041"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.717 70.251a4.94 4.94 0 1 0 9.878 0 4.94 4.94 0 0 0-9.878 0ZM97.715 70.28h-2.17M47.597 70.223h2.171M72.685 45.192v2.171M72.628 95.31v-2.172M68.95 66.544l-6.363-6.363M76.149 66.759l12.65-12.65M29.71 84.713H11.719M27.657 71.017H15M29.084 57.32H2.345M35.022 43.625H18.32"
}))));
export { SvgTimeSpeed as ReactComponent };
export default __webpack_public_path__ + "/assets/2259158723d764fd2d9f61e505b75c97.svg";